<template>
  <div class="workbench">
    <img class="workbench_img" src="../../assets/img/home/homepage.png" alt="">
    <!-- <div class="work_body"> -->

    <!-- </div> -->

  </div>
</template>
<script>
  import GlobalUtil from '@/utils/globalUtil';
  export default {
    data() {
      return {
        weatherInfo: {},

      }
    },
    created() {
    },
    methods: {
      getTianQi() {
        this.$axios.get(this.$url.getTianQi, {
          city: '深圳'
        }).then(res => {
          this.weatherInfo = res.data;
        })
      },
      quickClick(row) {
        console.log(row)
        if (row.ref) {
          this.$refs[row.ref].openDialog()
        }
      }
    },
    computed: {
      username() {
        let username = '王大发';
        return username
      },
      userInfo() {
        return GlobalUtil.getSessionStorage('userInfo')
      },
     
    }
  }

</script>
<style lang="scss" scoped>
  .workbench {
    height: 100%;
    background: #ffffff;
    position: relative;
  }
  .workbench_img{
    width: 100%;
    height: 100%;
  }
  .work_body{
    width: 1366px;
    height: 680px;
    background: url('../../assets/img/home/homepage.png') no-repeat;
    background-size: contain;
    position: absolute;
    bottom:50px;
    left:50%;
    margin-left: -685px;
  }
</style>